var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view"},[_c('alert',{staticClass:"form__alert",attrs:{"type":"fail"}},[_vm._v("Страница не найдена")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }